

export default {

    async SET_TOTAL_SUPPLIES_ORDER(state, totalSuppliesOrders) {
        state.totalSuppliesOrders = totalSuppliesOrders
    },
    async ADD_NEW_SUPPLIES_ORDER(state, order) {
        state.suppliesOrders.splice(0, 0, order) 
    },
    async SET_SUPPLIES_ORDER(state, suppliesOrders) {
        state.suppliesOrders = suppliesOrders
    },
    async UPDATE_SUPPLIES_ORDER(state, order) {
        const suppliesOrderIndex = state.suppliesOrders.findIndex((p) => p.idOrder == order.idOrder)
        Object.assign(state.suppliesOrders[suppliesOrderIndex], order)
    },

    REMOVE_SUPPLIES_ORDER(state, idOrder) {
        const suppliesOrderIndex = state.suppliesOrders.findIndex((s) => s.idOrder == idOrder)
        state.suppliesOrders.splice(suppliesOrderIndex, 1)
    },
  
    async SET_SUPPLIES_ORDER_FILTERED(state, suppliesOrders) {
        state.suppliesOrdersFiltered = suppliesOrders
    },

    REMOVE_SUPPLIES_ORDER_FILTERED(state, idOrder) {
        const suppliesOrderIndex = state.suppliesOrdersFiltered.findIndex((s) => s.idOrder == idOrder)
        state.suppliesOrdersFiltered.splice(suppliesOrderIndex, 1)
    },

}